module.exports = __webpack_public_path__ + "br.svg?182f9e334da7c92b4fa97c61078a96b7";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/br.svg
// module id = 1426
// module chunks = 27